
import Vue from 'vue'
import { Article } from '@/model/Article'
import SubmenuPage from '@/components/SubmenuPage.vue'
import UserEmblem from '@/components/user/Emblem.vue'
import shareMixin from "@/service/Share";

export default Vue.extend({
  name: 'Article',
  mixins: [shareMixin],
  components: {
    SubmenuPage,
    UserEmblem,
  },
  computed: {
    apiEndpoint(): string {
      const mapping: Record<string, string> = {
        'news': 'newses',
        'learn': 'learns'
      };
      return mapping[this.category] || this.category;
    },

    canonicalLink: function (): string {
      if (!this.article) {
        return '/'
      }
      return (
        'https://' + window.location.hostname + '/article/' + this.article.slug
      )
    },
    showBookmarkAction: function (): boolean {
      if (!this.article) {
        return false
      }
      return this.category === 'learn' ? true : false
    },
  },
  props: {
    slug: {
      type: String,
    },
    category:{
      type: String,
    }
  },
  mounted() {
    this.fetch()
  },
  data: () => ({
    article: null as Article | null,
  }),
  methods: {
    fetch: function () {
      this.$api
        .get(`/articles/${this.apiEndpoint}/` + this.slug)
        .then((response) => {
          this.article = response.data
        })
        .catch(() => this.$router.push('/404'))
    },
    bookmark: function () {
      if (!this.$store.state.authentication.signedIn) {
        this.$store.dispatch(
          'alert/info',
          'Register new account or sign in order to bookmark articles.'
        )
        return
      }

      if (!this.article) {
        return
      }

      this.$api
        .post('/likes/articles' + this.article.id)
        .then((response: any) => {
          if (!this.article) {
            return
          }
          this.article.isFavourite = response.data.isLiked
          const message = response.data.isLike
            ? 'Article has been added to your favourite articles.'
            : 'Article has been removed from your favourite articles.'
          this.$store.dispatch('alert/success', message)
        })
    },
  },
  watch: {
    $route: function () {
      this.fetch()
    },
  },
})
